import { Responsive } from '@cian/ui-kit';
import { FC } from 'react';

import { Button } from 'shared/components/Button';
import { TPlatform, EMobileDeviceType } from 'shared/types/platform';

import { APP_BUTTONS, EAppService } from './constants';

interface IButtonsGroupContainerProps {
  platform: TPlatform;
  onClick: (buttonName: string) => void;
}

export const ApplicationDownloadButtonContainer: FC<IButtonsGroupContainerProps> = ({ platform, onClick }) => {
  return (
    <Responsive phone>
      {platform === EMobileDeviceType.iOS && <Button {...APP_BUTTONS[EAppService.AppStore]} onClick={onClick} />}
      {platform === EMobileDeviceType.Android && <Button {...APP_BUTTONS[EAppService.GooglePlay]} onClick={onClick} />}
    </Responsive>
  );
};
